"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelGammaBrightnessCorrection = exports.CollectionModelGammaBrightnessCorrectionMutator = void 0;
var tslib_1 = require("tslib");
var brightnessCorrection_1 = require("./brightnessCorrection");
var CollectionModelGammaBrightnessCorrectionMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelGammaBrightnessCorrectionMutator, _super);
    function CollectionModelGammaBrightnessCorrectionMutator(brightnessCorrection) {
        return _super.call(this, brightnessCorrection) || this;
    }
    CollectionModelGammaBrightnessCorrectionMutator.prototype.init = function (exponent) {
        this.brightnessCorrection.brightnessCorrectionState.Mutator.create('gamma');
        this.setExponent(exponent);
    };
    CollectionModelGammaBrightnessCorrectionMutator.prototype.setExponent = function (exponent) {
        var state = this.getValue();
        state.exponent = exponent;
        this.setValue(state);
    };
    return CollectionModelGammaBrightnessCorrectionMutator;
}(brightnessCorrection_1.CollectionModelBrightnessCorrectionMutator));
exports.CollectionModelGammaBrightnessCorrectionMutator = CollectionModelGammaBrightnessCorrectionMutator;
var CollectionModelGammaBrightnessCorrection = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelGammaBrightnessCorrection, _super);
    function CollectionModelGammaBrightnessCorrection() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.tag = CollectionModelGammaBrightnessCorrection.TAG;
        _this.Mutator = new CollectionModelGammaBrightnessCorrectionMutator(_this);
        return _this;
    }
    CollectionModelGammaBrightnessCorrection.state = function (id) {
        return {
            id: id,
            tag: 'gamma',
            exponent: 1
        };
    };
    CollectionModelGammaBrightnessCorrection.isGamma = function (t) {
        return t.tag === CollectionModelGammaBrightnessCorrection.TAG;
    };
    Object.defineProperty(CollectionModelGammaBrightnessCorrection.prototype, "exponent", {
        get: function () {
            var state = this.state;
            if (!state) {
                return 1;
            }
            return state.exponent;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelGammaBrightnessCorrection.TAG = 'gamma';
    return CollectionModelGammaBrightnessCorrection;
}(brightnessCorrection_1.CollectionModelBrightnessCorrection));
exports.CollectionModelGammaBrightnessCorrection = CollectionModelGammaBrightnessCorrection;
//# sourceMappingURL=gamma.brightnessCorrection.js.map